<template>
  <div>
    <div v-if="loading" class="wrap-info-loading">
      <t-placeholder :lines="2" />
    </div>
    <div v-if="hasCampaign && !loading" class="wrapper-general-info">
      <div class="wrap-info">
        <span class="label-info" >Total de cadastrados</span>
        <span v-if="metaDataPeople.totalCount.toLocaleString('pt-BR')" class="value-info" v-text="metaDataPeople.totalCount.toLocaleString('pt-BR')"/>
      </div>

      <div
        v-for="(info, value, i) in kpiData"
        :key="i"
        class="wrap-info"
        :class="info === 'KpiPeople' ? 'hide' : ''"
        :data-type="value === 'peopleExpiredCount' ? 'expired': '' || value === 'peopleFailAtCreateCount' ? 'fail_at_create': '' || value === 'peoplePaidCount' ? 'paid': '' || value === 'peopleRegisteredCount' ? 'registered': '' || value === 'peopleImportedCount' ? 'imported': '' || value === 'peopleFailAtRegisterCount' ? 'fail_at_create': '' || value === 'peopleRegisteringCount' ? 'registering': ''">
        <span class="label-info" v-text="value === 'peopleExpiredCount' ? 'Expirados': '' || value === 'peopleFailAtCreateCount' ? 'Falha na Criação': '' || value === 'peoplePaidCount' ? 'Pagos': '' || value === 'peopleRegisteredCount' ? 'Registrados': '' || value === 'peopleImportedCount' ? 'Importados': '' || value === 'peopleFailAtRegisterCount' ? 'Falha no registro': '' || value === 'peopleRegisteringCount' ? 'Registrando': ''" />
        <span class="value-info" v-text="info.toLocaleString('pt-BR')"/>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState({
      loading: ({ people }) => people.loading,
      metaDataPeople: ({ people }) => people.metaDataPeople,
      kpiData: ({ people }) => people.kpiData,
      campaignId: ({ campaign }) => campaign.campaign.id,
      hasCampaign: ({ campaign }) => campaign.campaign
    }),
  },

  mounted () {
    if (this.hasCampaign) {
      this.getKpi({campaignId: Number(this.campaignId)})
    }
  },

  methods: {
    ...mapActions('people', ['getKpi']),
  }
}
</script>

<style lang="scss">
@import "@/assets/css/colors.scss";
.wrap-info-loading {
  height: 54px;
  width: 100%;
}

.wrapper-general-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;

  .wrap-info {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    &.hide {
      display: none;
    }

    &:first-child {
      align-items: flex-start;
      margin-right: 80px;
    }

    .label-info {
      font-size: 12.8px;
      line-height: 18px;
      color: $gray-500;
    }

    .value-info {
      font-size: 20px;
      line-height: 29px;
      font-weight: 700;
      color: $gray-600;
    }

    &[data-type="paid"] {
      .value-info {
        color: $green-500;
      }
    }

    &[data-type="registered"] {
      .value-info {
        color: $blue-500;
      }
    }

    &[data-type="registering"] {
      .value-info {
        color: $gray-300;
      }
    }

    &[data-type="expired"] {
      .value-info {
        color: $purple-500;
      }
    }

    &[data-type="imported"] {
      .value-info {
        color: $yellow-500;
      }
    }

    &[data-type="fail_at_create"] {
      .value-info {
        color: $red-500;
      }
    }
  }

}
</style>
